import Menu from '@/components/Menu.vue'

export default {
  name: 'menu-tab',
  components: {
    Menu
  }
}
